import { ref } from 'vue'
import { defineStore } from 'pinia'

import {
  sendRequest,
  resetRequestStatus,
  convertApiDataFromStore,
} from '@services/api/requestStoreUtils'

import {
  type SendRequestConfig,
  type EndpointConfig,
  type ResetRequestStatusConfig,
} from '@services/api/declarations'

import {
  type ClubStoreShape,
} from '@services/Club/declarations'

// ***
// CLUB STORE
// ***

export const useApiClubStore = defineStore('apiClub', () => {
  const store = useApiClubStore()

  // ***
  // STATE
  // ***

  const getClubs = ref<ClubStoreShape['getClubs']>()
  const getClubByHash = ref<ClubStoreShape['getClubByHash']>()
  const getClubByShortName = ref<ClubStoreShape['getClubByShortName']>()
  const getClubEnabledFeatures = ref<ClubStoreShape['getClubEnabledFeatures']>()
  const getClubProfiles = ref<ClubStoreShape['getClubProfiles']>()
  const getClubPaymentsMethodsOnboardLinks = ref<ClubStoreShape['getClubPaymentsMethodsOnboardLinks']>()
  const getClubPaymentsOnboard = ref<ClubStoreShape['getClubPaymentsOnboard']>()

  return {
    // State
    getClubs,
    getClubByHash,
    getClubByShortName,
    getClubEnabledFeatures,
    getClubProfiles,
    getClubPaymentsMethodsOnboardLinks,
    getClubPaymentsOnboard,

    // Actions
    sendRequest: <Config>(
      config: SendRequestConfig<Config>,
    ): ReturnType<typeof sendRequest> => sendRequest(store, config),
    resetRequestStatus: (
      storeKey: ResetRequestStatusConfig['storeKey'],
      kind: ResetRequestStatusConfig['kind'],
    ): ReturnType<typeof resetRequestStatus> => resetRequestStatus(store, storeKey, kind),
    convertApiDataFromStore: (
      storeKey: EndpointConfig['storeKey'],
      result: Record<string, unknown>,
    ): ReturnType<typeof convertApiDataFromStore> => convertApiDataFromStore(store, storeKey, result),
  }
})
